module.exports = __webpack_public_path__ + "fonts/boxicons.86708f26.woff";